import styled, { css } from 'styled-components'

import { outlineStyles } from 'components/Editor/styled/Outline'

import LinkStyled from './LinkStyled'

const placeholder = css`
  font-size: 14px;
  color: var(--color-placeholder);

  &:hover {
    color: var(--color-placeholder);
  }
`

const RootLinkStyled = styled.a<{ $placeholder: boolean }>`
  display: block;
  min-height: 56px;
  padding: 16px;
  word-break: break-word;

  ${({ $placeholder }) => $placeholder && placeholder}

  &:focus-visible {
    ${LinkStyled} {
      ${outlineStyles}
    }
  }
`

export default RootLinkStyled
